import { Getters } from '@/shared/app/model/store/getters';

export function activeDishesIndexesInDataset(getters: Getters, dataset: string, maxDishes = 24) {
  const actives: number[] = [];
  if (!getters.all) return [];
  const values = getters.all(dataset);
  for (let i = 1; i <= maxDishes; i += 1) if (values[`dish${i}_enable`] === true) actives.push(i);
  return actives;
}
